"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductModalButton = void 0;
const utils_1 = require("../../utils/utils");
const modal_button_1 = require("../../components/modal/modal-button");
class ProductModalButton extends modal_button_1.ModalButton {
    trigger() {
        super.trigger();
        const modal = (0, utils_1.$el)(this.dataset.modal);
        modal?.openAndShowMediaById(this.dataset.mediaId);
    }
}
exports.ProductModalButton = ProductModalButton;
